import React from 'react';
import styles from './styles.module.scss';
import {Flex, Text} from '@priority-software/priority-style-react';
import {PartsDetails} from '../../types';

interface Props {
    part: PartsDetails;
}
const Title = ({part}: Props) => {
    const {partName, family, familyName} = part;
    return (
        <Flex
            componentClasses={styles.TitleContainer}
            justifyContent="flex-start"
            alignItems="center"
        >
            <Text textColor="primary-700" skin="subtitle-1">
                {partName}
            </Text>
            <div className={styles.familyDescription}>
                <Text textColor="secondary-500" skin="label-1">{`${familyName} | ${family}`}</Text>
            </div>
        </Flex>
    );
};

export default Title;
